// Currently, there is no shared cache for the sidebar cards,
// so the workaround here is to use this constant for whenever we need to
// dispatch an event to refresh the payment timeline events and the
// eventListeners will trigger a refetch.
export const REFRESH_PAYMENT_TIMELINE_EVENTS = 'refreshPaymentTimelineEvents';